import { EntitySource } from 'src/constants';
import { IMenu } from 'src/types/menu.types';

const isCompatible = (menu: IMenu, source: EntitySource, sourceIds: string[]): boolean => {
  if (source === EntitySource.RANGES) return (menu.ranges ?? []).some(({ range_id }) => sourceIds.includes(range_id));
  if (source === EntitySource.MENU_LABELS) {
    return (menu.menuLabels ?? []).some(({ menu_label_id }) => sourceIds.includes(menu_label_id));
  }
  return true;
};

/**
 * The menus a menu set can take, sorted by name. `sourceIds` are the set's range ids for a ranged set, or its
 * source menu label ids for a label-sourced one; a menu needs any one of them.
 */
export const getCompatibleMenus = (menus: IMenu[], source: EntitySource, sourceIds: string[]): IMenu[] =>
  menus.filter((menu) => isCompatible(menu, source, sourceIds)).sort((a, b) => a.name.localeCompare(b.name));
